/* eslint-disable */
// https://dev2.bhsn.it/api/alex/swagger-ui/index.html
import type { AxiosPromise, AxiosInstance } from 'axios';
import { toAxiosOptions, mergeObjects } from '@allibee/utils';

let axiosInstance: AxiosInstance;
let baseURL: string;

const serviceRoute = 'alex';
export function setupServiceInstance(callback: (serviceRoute: string) => { baseURL: string; instance: AxiosInstance }) {
    const result = callback(serviceRoute);
    axiosInstance = result.instance;
    baseURL = result.baseURL;
}

export function getBaseURL() {
    return baseURL;
}

/**
 * 체결본 Bulk 요청 참조자 수정 V1
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractBulkRequestWatchers(
    {
        requestBody,
    }: {
        requestBody: AlexContractBulkRequestUsersUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/bulk-requests/users/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 Bulk 요청 Retry V1
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function retryContractBulkRequest(
    {
        requestBody,
    }: {
        requestBody: AlexContractBulkRequestRetryForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/bulk-requests/retry/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 Bulk 등록 시작 V1
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function registerContractBulkRequest(
    {
        requestBody,
    }: {
        requestBody: AlexContractBulkRequestRegisterForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/bulk-requests/register/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 Bulk 요청 소유 부서 수정 V1
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractBulkRequestGroup(
    {
        requestBody,
    }: {
        requestBody: AlexContractBulkRequestGroupUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/bulk-requests/groups/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 Bulk 요청 확인 V1
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function confirmContractBulkRequest(
    {
        requestBody,
    }: {
        requestBody: AlexContractBulkRequestConfirmForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/bulk-requests/confirm/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 일괄 업로드 리스트 검색
 * @returns AlexResponseListContractBulkRequestDto OK
 * @throws ApiError
 */
export function getContractBulkRequests(
    {
        executionStatus,
    }: {
        /**
         * 체결본 상태
         */
        executionStatus?: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponseListContractBulkRequestDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contracts/bulk-requests/v1',
                query: {
                    executionStatus: executionStatus,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 Bulk 요청 생성 V1
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function createContractBulkRequest(
    {
        requestBody,
    }: {
        requestBody: AlexContractBulkRequestCreateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contracts/bulk-requests/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 Bulk 요청 삭제 V1
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function deleteContractBulkRequest(
    {
        requestBody,
    }: {
        requestBody: AlexContractBulkRequestDeleteForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/contracts/bulk-requests/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 Bulk 요청 - 다운로드 V1
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function downloadByContractBulkRequestId(
    {
        requestId,
    }: {
        requestId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contracts/bulk-requests/{requestId}/download/v1',
                path: {
                    requestId: requestId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 일괄 업로드 페이징 검색 - page V2
 * @returns AlexResponsePageContractBulkRequestDtoV2 OK
 * @throws ApiError
 */
export function pageContractBulkRequestsV2(
    {
        executionStatus,
        sortField,
        sortDirection,
        page,
        size = 10,
        sort,
    }: {
        /**
         * 체결본 상태
         */
        executionStatus?: string;
        /**
         * 정렬 기준
         */
        sortField?: string;
        /**
         * 정렬 방향
         */
        sortDirection?: string;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponsePageContractBulkRequestDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contracts/bulk-requests/page-search/v2',
                query: {
                    executionStatus: executionStatus,
                    sortField: sortField,
                    sortDirection: sortDirection,
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 일괄 업로드 페이징 검색 - page V1
 * @returns AlexResponsePageContractBulkRequestDto OK
 * @throws ApiError
 */
export function pageContractBulkRequests(
    {
        executionStatus,
        sortField,
        sortDirection,
        page,
        size = 10,
        sort,
    }: {
        /**
         * 체결본 상태
         */
        executionStatus?: string;
        /**
         * 정렬 기준
         */
        sortField?: string;
        /**
         * 정렬 방향
         */
        sortDirection?: string;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponsePageContractBulkRequestDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contracts/bulk-requests/page-search/v1',
                query: {
                    executionStatus: executionStatus,
                    sortField: sortField,
                    sortDirection: sortDirection,
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 Bulk 요청 상태별 카운트 V1
 * @returns AlexResponseContractBulkRequestCountDto OK
 * @throws ApiError
 */
export function countContractBulkRequest(_?: any, requestConfig?: RequestConfig): AxiosPromise<AlexResponseContractBulkRequestCountDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contracts/bulk-requests/count-by-status/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * Add or update executed contract information.
 * | If you need delete executed contract information, use separate delete API.
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function migrateContracts(
    {
        requestBody,
    }: {
        requestBody: AlexWorkspaceContractMigrationForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/external/migrations/contracts/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * @returns any OK
 * @throws ApiError
 */
export function deleteAllByCodes(
    {
        requestBody,
    }: {
        requestBody: AlexContractDeleteByCodesForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<any> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/external/migrations/contracts/by-codes/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 해시태그 조회
 * @returns AlexResponseListHashtagDto OK
 * @throws ApiError
 */
export function getHashtagV1(_?: any, requestConfig?: RequestConfig): AxiosPromise<AlexResponseListHashtagDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/hashtags/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 해시태그 등록하기 V1
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function addHashtagV1(
    {
        requestBody,
    }: {
        requestBody: AlexHashtagForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/hashtags/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 파일 OCR 결과 조회
 * @returns AlexResponseOcrDto OK
 * @throws ApiError
 */
export function ocrFile(
    {
        requestBody,
    }: {
        requestBody: AlexOcrFileForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponseOcrDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/ocr/files/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 OCR 결과 조회
 * @returns AlexResponseOcrDto OK
 * @throws ApiError
 */
export function getExecutedCopyOcrResult(
    {
        contractId,
    }: {
        contractId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponseOcrDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/ocr/executed-copies/{contractId}/v1',
                path: {
                    contractId: contractId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * Conhub 계약서 OCR 결과 조회
 * @returns AlexResponseOcrDto OK
 * @throws ApiError
 */
export function ocrConhubContract(
    {
        contractId,
        revision,
    }: {
        contractId: number;
        revision: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponseOcrDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/ocr/conhub-contracts/{contractId}/revision/{revision}/v1',
                path: {
                    contractId: contractId,
                    revision: revision,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * id 범위의 계약서를 Elasticsearch에 재색인하기 V1
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function reindexByIdRange(
    {
        idStart,
        idEnd,
    }: {
        idStart: number;
        idEnd: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contracts/reindex/id-range/v1',
                query: {
                    idStart: idStart,
                    idEnd: idEnd,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 전체 계약서를 Elasticsearch에 재색인하기 V1
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function reindexAll(_?: any, requestConfig?: RequestConfig): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contracts/reindex/all/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 - User Config 조회
 * @returns AlexResponseUserConfigDto OK
 * @throws ApiError
 */
export function getUserConfig(_?: any, requestConfig?: RequestConfig): AxiosPromise<AlexResponseUserConfigDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contracts/user-config/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 - User Config 수정
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateUserConfig(
    {
        requestBody,
    }: {
        requestBody: AlexUserConfigForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/user-config/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 관할 법원 수정
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractVenue(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractVenueUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/venue/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 수정하기 V3
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractV3(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractUpdateFormV3;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/v3',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 체결본 수정하기 V2
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractV2(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractUpdateFormV2;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/v2',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 참조자 수정
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractUserIds(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractUsersUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/users/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 제목 수정
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractTitle(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractTitleUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/title/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 계약 시작 / 종료일 수정
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractStartAndEndDate(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractStartAndEndDateUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/start-end-date/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 간단 수정하기 V2
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractSimpleV2(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractSimpleUpdateFormV2;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/simple/v2',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 체결본 간단 수정하기 V1
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function patchContractSimpleV1(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractSimpleUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/simple/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 서명방식 수정
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractSigningType(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractSigningTypeUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/signingType/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 계약 체결일 수정
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractSignedDate(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractSignedDateUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/signed-date/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 참조 부서 리스트 수정
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractReferenceGroups(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractReferenceGroupsUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/referenceGroups/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 자사 지위 수정
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractOurPosition(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractOurPositionUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/our-position/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 계약 메모 수정
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractMemo(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractMemoUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/memo/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 해시태그 수정
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractHashtags(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractHashtagsUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/hashtags/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 준거법 수정
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractGoverningLaw(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractGoverningLawUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/governing-law/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 파일 수정
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractFiles(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractFilesUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/files/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 분쟁해결 방법 수정
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractDisputeResolutionMethod(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractDisputeResolutionMethodUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/dispute-resolution-method/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 계약 상대방 수정
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractCounterparties(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractCounterpartiesUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/counterparties/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 계약 금액 / 통화 수정
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractAmountAndCurrency(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexContractAmountAndCurrencyUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/amount-currency/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 - zip 다운로드
 * @returns any OK
 * @throws ApiError
 */
export function downloadZip(
    {
        requestBody,
    }: {
        requestBody: AlexContractZipDownloadCondition;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<any> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contracts/zip/download/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 등록하기 V8
 * @returns AlexResponseContractCreateResponseDto OK
 * @throws ApiError
 */
export function createContractV8(
    {
        requestBody,
    }: {
        requestBody: AlexContractCreateFormV8;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponseContractCreateResponseDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contracts/v8',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 체결본 등록하기 V7
 * @returns AlexResponseContractCreateResponseDto OK
 * @throws ApiError
 */
export function createContractV7(
    {
        requestBody,
    }: {
        requestBody: AlexContractCreateFormV7;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponseContractCreateResponseDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contracts/v7',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 체결본 등록하기 V6
 * @returns AlexResponseContractCreateResponseDto OK
 * @throws ApiError
 */
export function createContractV6(
    {
        requestBody,
    }: {
        requestBody: AlexContractCreateFormV6;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponseContractCreateResponseDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contracts/v6',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 무한 스크롤 검색 V2
 * @returns AlexResponseListContractScrollSearchResultV2 OK
 * @throws ApiError
 */
export function scrollSearchContractsV2(
    {
        requestBody,
        fetchSize,
        sortValue,
        tieBreaker,
    }: {
        requestBody: AlexContractScrollSearchConditionV2;
        /**
         * 가져올 데이터 수
         */
        fetchSize?: number;
        /**
         * 마지막 데이터의 sortValue - 조회 조건이 있으면 score 값, 없으면 createdAt 값
         */
        sortValue?: string;
        /**
         * 마지막 데이터의 tieBreaker
         */
        tieBreaker?: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponseListContractScrollSearchResultV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contracts/scroll-search/v2',
                query: {
                    fetchSize: fetchSize,
                    sortValue: sortValue,
                    tieBreaker: tieBreaker,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 시맨틱 검색 V1 - FE에서 스크롤 방식으로 전환하면 사용하지 않을 예정
 * @returns AlexResponsePageContractPageSearchResultV4 OK
 * @throws ApiError
 */
export function pageSemanticSearchContractsV1(
    {
        requestBody,
        page,
        size = 10,
        sort,
    }: {
        requestBody: AlexContractPageSearchConditionV2;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponsePageContractPageSearchResultV4> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contracts/page-semantic-search/v1',
                query: {
                    page: page,
                    size: size,
                    sort: sort,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 페이징 검색 V5 - 검색 대상(제목/내용/ID) 선택 지원
 * @returns AlexResponsePageContractPageSearchResultV4 OK
 * @throws ApiError
 */
export function pageSearchContractsV5(
    {
        requestBody,
        page,
        size = 10,
        sort,
    }: {
        requestBody: AlexContractPageSearchConditionV5;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponsePageContractPageSearchResultV4> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contracts/page-search/v5',
                query: {
                    page: page,
                    size: size,
                    sort: sort,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 페이징 검색 V4 - FE에서 스크롤 방식으로 전환하면 사용하지 않을 예정
 * @returns AlexResponsePageContractPageSearchResultV4 OK
 * @throws ApiError
 */
export function pageSearchContractsV4(
    {
        requestBody,
        page,
        size = 10,
        sort,
    }: {
        requestBody: AlexContractPageSearchConditionV2;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponsePageContractPageSearchResultV4> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contracts/page-search/v4',
                query: {
                    page: page,
                    size: size,
                    sort: sort,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 페이징 검색 V3 - FE에서 스크롤 방식으로 전환하면 사용하지 않을 예정
 * @returns AlexResponsePageContractPageSearchResultV3 OK
 * @throws ApiError
 */
export function pageSearchContractsV3(
    {
        requestBody,
        page,
        size = 10,
        sort,
    }: {
        requestBody: AlexContractPageSearchConditionV2;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponsePageContractPageSearchResultV3> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contracts/page-search/v3',
                query: {
                    page: page,
                    size: size,
                    sort: sort,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 - 엑셀 다운로드 V2
 * @returns any OK
 * @throws ApiError
 */
export function excelContractsV2(
    {
        requestBody,
    }: {
        requestBody: AlexContractScrollSearchConditionV2;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<any> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contracts/excel/v2',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 - 목록 다운로드 V1
 * @returns any OK
 * @throws ApiError
 */
export function excelMetaDownloadContracts(
    {
        requestBody,
    }: {
        requestBody: AlexContractExcelDownloadCondition;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<any> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contracts/excel/meta/download/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 분석하기 V3
 * @returns AlexResponseContractAnalysisDtoV2 OK
 * @throws ApiError
 */
export function analyzeContractV3(
    {
        requestBody,
    }: {
        requestBody: AlexContractAnalyzerFormV2;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponseContractAnalysisDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contracts/analyze/v3',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 코드 목록 V2
 * @returns any OK
 * @throws ApiError
 */
export function getRepositoryCodesV2(_?: any, requestConfig?: RequestConfig): AxiosPromise<Record<string, Array<Record<string, any>>>> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/repository-codes/v2',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 상세 조회 V6
 * @returns AlexResponseContractDtoV6 OK
 * @throws ApiError
 */
export function getContractV6(
    {
        contractId,
    }: {
        contractId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponseContractDtoV6> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contracts/{contractId}/v6',
                path: {
                    contractId: contractId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 상세 조회 V5
 * @returns AlexResponseContractDtoV5 OK
 * @throws ApiError
 */
export function getContractV5(
    {
        contractId,
    }: {
        contractId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponseContractDtoV5> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contracts/{contractId}/v5',
                path: {
                    contractId: contractId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 PDF 다운로드
 * @returns any OK
 * @throws ApiError
 */
export function downloadContract(
    {
        contractId,
    }: {
        contractId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<any> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contracts/{contractId}/download/v1',
                path: {
                    contractId: contractId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 상세 조회 by conhub contract ID V4
 * @returns AlexResponseContractDtoV6 OK
 * @throws ApiError
 */
export function getContractByConhubContractIdV4(
    {
        conhubContractId,
    }: {
        /**
         * Conhub 계약 ID
         */
        conhubContractId?: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponseContractDtoV6> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contracts/v4',
                query: {
                    conhubContractId: conhubContractId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 상세 조회 by conhub contract ID V3
 * @returns AlexResponseContractDtoV5 OK
 * @throws ApiError
 */
export function getContractByConhubContractIdV3(
    {
        conhubContractId,
    }: {
        /**
         * Conhub 계약 ID
         */
        conhubContractId?: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponseContractDtoV5> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contracts/v3',
                query: {
                    conhubContractId: conhubContractId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 PDF 다운로드 by conhub contract ID
 * @returns any OK
 * @throws ApiError
 */
export function downloadContractByConhubContractId(
    {
        conhubContractId,
    }: {
        /**
         * Conhub 계약 ID
         */
        conhubContractId?: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<any> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contracts/download/by-conhub-contract-id/v1',
                query: {
                    conhubContractId: conhubContractId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크스페이스 계약 타입 조회
 * @returns AlexResponseListWorkspaceContractTypeDto OK
 * @throws ApiError
 */
export function getContractTypes(_?: any, requestConfig?: RequestConfig): AxiosPromise<AlexResponseListWorkspaceContractTypeDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contract-types/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 삭제
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function deleteContract(
    {
        contractId,
    }: {
        contractId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/contracts/{contractId}/v1',
                path: {
                    contractId: contractId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 라벨 조항 삭제
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function deleteLabelClauseExtraction(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexLabelClauseExtractionDeleteForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/contracts/{contractId}/labelClauseExtraction/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 리마인더 조회
 * @returns AlexResponseContractReminderDto OK
 * @throws ApiError
 */
export function getContractReminder(
    {
        contractId,
        reminderId,
    }: {
        contractId: number;
        reminderId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponseContractReminderDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contracts/{contractId}/reminders/{reminderId}/v1',
                path: {
                    contractId: contractId,
                    reminderId: reminderId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 리마인더 업데이트
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function updateContractReminder(
    {
        contractId,
        reminderId,
        requestBody,
    }: {
        contractId: number;
        reminderId: number;
        requestBody: AlexReminderCreateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/contracts/{contractId}/reminders/{reminderId}/v1',
                path: {
                    contractId: contractId,
                    reminderId: reminderId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 리마인더 삭제
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function deleteContractReminder(
    {
        contractId,
        reminderId,
    }: {
        contractId: number;
        reminderId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/contracts/{contractId}/reminders/{reminderId}/v1',
                path: {
                    contractId: contractId,
                    reminderId: reminderId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 리마인더 목록 조회
 * @returns AlexResponseListContractReminderSimpleDto OK
 * @throws ApiError
 */
export function getContractReminderList(
    {
        contractId,
    }: {
        contractId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponseListContractReminderSimpleDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/contracts/{contractId}/reminders/v1',
                path: {
                    contractId: contractId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 리마인더 생성
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function createContractReminder(
    {
        contractId,
        requestBody,
    }: {
        contractId: number;
        requestBody: AlexReminderCreateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/contracts/{contractId}/reminders/v1',
                path: {
                    contractId: contractId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 체결본 Bulk 등록 V1
 * @returns AlexResponse OK
 * @throws ApiError
 */
export function createBulkContractsV1(
    {
        requestBody,
    }: {
        requestBody: AlexContractBulkCreateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/super-admin/contracts/bulk/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 통합 검색 (페이지)
 * @returns AlexResponsePageUnifiedSearchPageResult OK
 * @throws ApiError
 */
export function pageSearchUnified(
    {
        requestBody,
        page,
        size = 10,
        sort,
    }: {
        requestBody: AlexUnifiedSearchCondition;
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<AlexResponsePageUnifiedSearchPageResult> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/unified-search/page/v1',
                query: {
                    page: page,
                    size: size,
                    sort: sort,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 통합 검색 코드 목록
 * @returns any OK
 * @throws ApiError
 */
export function getUnifiedSearchCodes(_?: any, requestConfig?: RequestConfig): AxiosPromise<Record<string, Array<Record<string, any>>>> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/unified-search-codes/v1',
            }),
            requestConfig,
        ),
    );
}
